import type { CreateSubscriptionSessionRequestMetadata } from './createSubscriptionSessionRequestMetadata';

export interface CreateSubscriptionSessionRequest {
  /** 추가 메타데이터 */
  metadata?: CreateSubscriptionSessionRequestMetadata;
  /** 구독할 플랜 ID */
  planId: string;
  /** 플랜 코드 (백엔드에서 플랜 검색에 사용) */
  productPlanCode?: string;
  /** 결제 완료 후 리다이렉트 URL */
  redirectUrl?: string;
  /** 사용자 ID */
  userId?: string;
}
